var translations_bitiba_de_DE = {
	"general.button.close": "Schließen"
};

export { translations_bitiba_de_DE as default };
//# sourceMappingURL=de_DE.json.js.map
